import type { Mission } from '../missions.ts'

export const fda: Mission = {
  id: "fda",
  name: "U.S. Food and Drug Administration",
  short: "FDA",
  call: "Food and Drugs",
  kind: "subagency",
  parent: "hhs",
  url: "https://www.fda.gov/",
  established: 1906,
  palette: {
    primary: "#007cba",
    secondary: "#222c67",
    accent: "#e5b611",
  },
  colorSource: {
    kind: "site",
    url: "https://www.fda.gov/",
  },
  motif: "flask",
  mission: {
    text: "For more than 100 years, the FDA has been working to carry out our mission of promoting and protecting public health, and that means your health.",
    url: "https://www.fda.gov/about-fda",
  },
  fact: {
    text: "FDA's modern regulatory work began with the 1906 Pure Food and Drugs Act; the agency took its present name in 1930.",
    url: "https://www.fda.gov/about-fda/fda-history",
  },
  logo: {
    file: "public/logos/fda.svg",
    source: "https://commons.wikimedia.org/wiki/File:Logo_of_the_United_States_Food_and_Drug_Administration.svg",
  },
  identifier: {
    about: "https://www.fda.gov/about-fda",
    accessibility: "https://www.fda.gov/about-fda/about-website/internet-accessibility",
    foia: "https://www.fda.gov/regulatory-information/freedom-information",
    noFear: "https://www.fda.gov/about-fda/jobs-and-training-fda/no-fear-act",
    oig: "https://oig.hhs.gov/",
    performance: "https://www.fda.gov/about-fda/performance-data/fda-track-agency-wide-program-performance",
    privacy: "https://www.fda.gov/about-fda/about-website/website-policies",
  },
  media: {
    photos: [
      {
        file: "/media/fda-white-oak-lab.jpg",
        small: "/media/fda-white-oak-lab-sm.jpg",
        alt: "The curved glass and steel Life Sciences Laboratory, Building 64, on FDA's White Oak campus at dusk.",
        title: "FDA Building 64, White Oak campus, Silver Spring, Maryland",
        creator: "U.S. Food and Drug Administration",
        source: "https://commons.wikimedia.org/wiki/File:FDA_Bldg_64_-_Exterior_(5161375466).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/fda-white-oak-entrance.jpg",
        small: "/media/fda-white-oak-entrance-sm.jpg",
        alt: "The brick main entrance of FDA Building 1, with 'Food and Drug Administration' lettered above the canopy.",
        title: "FDA Building 1 main entrance, White Oak campus",
        creator: "U.S. Food and Drug Administration",
        source: "https://commons.wikimedia.org/wiki/File:FDA_Entrance_(16792957331).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
